export default new RegExp(
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()-+=_`~,><\\/\\"\'?;: {[}\\]])[A-Za-z\\d!@#$%^&*()-+=_`~,><\\/\\"\'?;: {[}\\]]{12,}',
);
